import { BazaNcIntegrationFeedDataAccessModule } from '@scaliolabs/baza-nc-integration-data-access';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { FeedState } from './state';

@NgModule({
    imports: [NgxsModule.forFeature([FeedState]), BazaNcIntegrationFeedDataAccessModule],
})
export class FeedStateModule {}
